import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { yupResolver } from '@hookform/resolvers/yup';
import { EyeFillIcon, EyeSlashFillIcon } from '@yonderland/andes-icons';
import { Banner, Box, IconButton, useMediaQueryMatchesOnMobile, Checkbox, LinkButton, Stack, TextField, Button, } from '@yonderland/andes-react';
import { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { LOGIN_FORM_ERROR_FEEDBACK_ID } from '../../constants/DOMElementsConstants';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import FormValidationUtil from '../../util/FormValidationUtil';
import { FormField } from '../form/FormField';
export const LoginForm = ({ onSubmit, successFeedback, errorFeedback, action, forgotPasswordClicked, initialEmail = '', loading, }) => {
    const ICON_PASSWORD_OFF = {
        color: 'active',
        source: EyeSlashFillIcon,
    };
    const ICON_PASSWORD_ON = {
        color: 'active',
        source: EyeFillIcon,
    };
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const isMobile = useMediaQueryMatchesOnMobile();
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [passwordIcon, setPasswordIcon] = useState(ICON_PASSWORD_OFF);
    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
        setPasswordIcon(isPasswordVisible ? ICON_PASSWORD_OFF : ICON_PASSWORD_ON);
    };
    const validationSchema = Yup.object({
        password: Yup.string().required(t(`delivery.required`)),
        email: Yup.string()
            .required(t(`delivery.required`))
            .matches(FormValidationUtil.emailPatternRegex, t('account.login.email.error.required')),
        keepSignedIn: Yup.boolean().required(),
    });
    const initialValues = {
        email: initialEmail,
        password: '',
        keepSignedIn: false,
    };
    const formProps = useForm({
        defaultValues: initialValues,
        mode: 'onTouched',
        resolver: yupResolver(validationSchema),
    });
    return (_jsx(FormProvider, Object.assign({}, formProps, { children: _jsx("form", { method: "post", action: action, onSubmit: formProps.handleSubmit(onSubmit), noValidate: true, children: _jsxs(Stack, { direction: "col", gap: "4", children: [successFeedback && _jsx(Banner, { status: "success", text: successFeedback }), errorFeedback && (_jsx(Box, { id: LOGIN_FORM_ERROR_FEEDBACK_ID, children: _jsx(Banner, { status: "error", text: errorFeedback, testId: "login-form-error-feedback" }) })), _jsx(FormField, { name: "email", children: (_a) => {
                            var options = __rest(_a.fieldProps, []), { error } = _a;
                            return (_jsx(TextField, Object.assign({}, options, { label: t('account.flyout.email.placeholder'), name: "email", id: "email", autoComplete: "email", type: "email", error: error, testId: "email-form-email" })));
                        } }), _jsx(FormField, { name: "password", required: true, children: (_a) => {
                            var options = __rest(_a.fieldProps, []), { error } = _a;
                            return (_jsx(TextField, Object.assign({}, options, { label: t('account.flyout.password.placeholder'), name: "password", id: "password", required: true, autoComplete: "current-password", error: error, type: isPasswordVisible ? 'text' : 'password', labelAdornment: !isMobile
                                    ? {
                                        text: t('navigation:flyout.account.password.forgotten'),
                                        onClick: () => forgotPasswordClicked === null || forgotPasswordClicked === void 0 ? void 0 : forgotPasswordClicked(),
                                    }
                                    : undefined, testId: "login-form-password", adornmentEnd: _jsx("div", { style: { pointerEvents: 'all' }, children: _jsx(IconButton, { size: "sm", variant: "plain", onClick: togglePasswordVisibility, icon: passwordIcon, testId: "show-password-button" }) }) })));
                        } }), isMobile && (_jsx(Box, { contentAlign: "start", children: _jsx(LinkButton, { theme: "neutral", onClick: forgotPasswordClicked, variant: "primary", size: "md", testId: "forgot_pwd_link", children: t('navigation:flyout.account.password.forgotten') }) })), _jsx(FormField, { name: "keepSignedIn", children: ({ fieldProps }) => (_jsx(Checkbox, Object.assign({}, fieldProps, { checked: fieldProps.value, label: t('navigation:flyout.account.keep.me.signed.in'), name: "keepSignedIn", id: "keepSignedIn", testId: "login-form-keep-signed-in", size: "xs" }))) }), _jsx(Button, { type: "submit", size: "sm", state: loading ? 'loading' : undefined, variant: "primary", theme: "branded", testId: "login_btn", children: t('account.login.title.login') })] }) }) })));
};
